module.exports = __webpack_public_path__ + "img/img-topo-quem-somos.69ff4e77.png";